import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, DatePicker, InputNumber, Switch, Tabs } from "antd";
import { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, formatNumber, formatDate, dayjsDate, getobjkeys, formatDate2, checkp, getAdmin, confirmBox } from '../../utils/functions'
import { PlusOutlined, EditOutlined, DeleteOutlined, DiffOutlined } from '@ant-design/icons';
import CustModal from "../../components/ShowModal";
import TbEditor from "../wlb/TbEditor";
import renderFileList from "../../components/renderFileList";
import ExpenditureForm from "./ExpenditureForm";
import ExpenditureDetails from "./ExpenditureDetails";
import DateSelector from '../../components/DateSelector';

const {Option} = Select;
const admin = getAdmin();
function ExpenditureList({ searchKeys }) {
    const webPost = useWebPost();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const pageSizeOptions = [10, 20, 50, 100, 500];

    const [form] = Form.useForm();
    const [editingRecord, setEditingRecord] = useState(null);
    const [dates, setDates] = useState({});
    const [activeKey, setActiveKey] = useState('0');

    const loadingRef = useRef();
    useEffect(() => {
        const fetchItems = () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            try {
                const params = { page: currentPage, limit: pageSize, ...searchKeys, ...filters, ...dates };
                webPost('expenditurelist', params).then((response) => {
                    if (response && response.data) {
                        if (response.total < 1) {
                            message.info('未找到匹配数据');
                        }
                        setData(response.data);
                        setTotal(response.total);
                    }
                })
            } catch (e) {
                setData([]);
                setTotal(0);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
        fetchItems();
    }, [searchKeys, currentPage, pageSize, freshData, activeKey]);

    const columns = [
        {
            title: '序号', dataIndex: 'xd', width: 54,
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        { title: '制单日期', dataIndex: 'make_date', width: 90 },
        { title: '项目名称', dataIndex: 'xmmc', width: 200, },
        { title: '制单人', dataIndex: 'maker_name', width: 100 },
        { title: '科目', dataIndex: 'km', width: 80 },
        { title: '科目名称', dataIndex: 'kmmc', width: 150 },
        { title: '付款金额', dataIndex: 'this_receipt_amount', width: 140, },
        {
            title: '状态', dataIndex: 'status', width: 100, render: (t, rs) => {
                let res = '';
                switch (Number(t)) {
                    case -1:
                        res = '审核被拒：';
                        break;
                    case 0:
                        res = '草稿';
                        break;
                    case 1:
                        res = '审核中';
                        break;
                    case 2:
                        res = '已归档';
                        break;
                }
                return res;
            }
        },
        { title: '备注', dataIndex: 'remark', width: 160, },
        { title: '附件', dataIndex: 'attachment', width: 100, render: (t, rs) => renderFileList(rs.attachment) },
        {
            title: '操作',
            key: 'action',
            width: 160,
            fixed: 'right',
            render: (_, record) => {
                const rst = [];
                const state = Number(record.status);
                switch (state) {
                    case -1: case 0:
                        if (record.maker_name === admin?.['name']) {
                            rst.push(<Button key={`key${record.id}-1`} type="link" icon={<EditOutlined />} onClick={() => showModal(record, 'edit')}>修改</Button>);
                        }
                        break;
                    case 2:
                        if (checkp('all') && record.category === '') {
                            rst.push(<Button type="link" key={`key${record.id}-2`} danger onClick={() => showModal(record, 'del')}>废弃</Button>);
                        }
                        break;
                }
                rst.push(<Button key={`key${record.id}-3`} onClick={() => showModal(record, "details")}>查看详情</Button>);
                return <div>{rst}</div>;

            },
        },
    ].filter(Boolean);

    const showModal = async (record = null, action) => {
        if (action === 'del') {
            confirmBox(async () => {
                const res = await webPost("delItem", {tb:'expend', id: record.id });
                if (res) {
                    message.success("删除成功!");
                    saveSuccess();
                } else {
                    message.error("删除失败!");
                }

            })
            return;
        }
        setEditingRecord(record);
        setModalVisible(action);
    };

    const handleModalClose = () => {
        setModalVisible('');
        setEditingRecord(null);
    }
    const saveSuccess = () => {
        setfreshData(Math.random()); //强制刷新数据
        handleModalClose();
    };
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    return (
        <FullHeightLayout
            headerContent={
                <Space size="middle">
                    <DateSelector  onChange={(v) => { setDates(v); }} />
                    <Select placeholder='类型' style={{width:'120px'}} onChange={(v) => setFilters(prev => ({ ...prev, "lx": v }))}>
                        <Option value='1'>项目名称</Option>
                        <Option value='2'>项目编号</Option>
                        <Option value='3'>制单人</Option>
                        <Option value='4'>科目代码</Option>
                        <Option value='5'>金额</Option>
                    </Select>
                    <Input onChange={(e)=> setFilters(prev=>({...prev, 'key':e.target.value}))} />
                    <Button type="primary" onClick={saveSuccess} >搜索</Button>
                    {/* <Button type="primary" icon={<PlusOutlined />} onClick={() => showModal(null, 'edit')}>新建支付申请</Button> */}
                </Space>
            }
            bodyContent={
                <>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey={(_, index) => index}
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 1280,
                            y: 'calc(100vh - 300px)',
                        }}
                        tableLayout="fixed"
                        onRow={(record, index) => ({
                            onDoubleClick: (event) => {
                                navigate('/htcx/' + record.sn);
                            },
                        })}
                    />
                    <TbEditor visible={modalVisible === 'details'}
                        currentItem={editingRecord}
                        webPost={webPost}
                        onClose={handleModalClose}
                        onSaveSuccess={saveSuccess} />
                    <CustModal title='详情' open={modalVisible === 'details'} onCancel={handleModalClose} footer={false}>
                        <ExpenditureDetails item={editingRecord} />
                    </CustModal>
                    <CustModal
                        title={editingRecord ? '修改支付申请' : '新建支付申请'}
                        open={modalVisible === 'edit'}
                        onCancel={handleModalClose}
                        footer={false}
                    >
                        <ExpenditureForm item={editingRecord} onSave={saveSuccess} />
                    </CustModal>
                </>
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                        onChange={onPageChange}
                        pageSizeOptions={pageSizeOptions}
                    />
                </div>
            }
        />
    )
}


export default ExpenditureList;
